export const VirtualRaceTypeValues = [
    'None',
    'Section',
    'CupIndividualProlog',
    'CupSameLevel',
    'BestLap',
    'CupUci',
    'CupFis',
    'ShowUrl',
    'ShowTriggerControl',
    'CUPNSFUPDOWN',
] as const;
export type VirtualRaceType = (typeof VirtualRaceTypeValues)[number];
